<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="for"><a id="page_vii"></a><a href="#/xhtml/foreword#for"><i>Foreword</i> by Daniel Castelo</a></p>
<p class="Toc1" id="pre"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc1" id="abb"><a href="#/xhtml/abbreviations#abb">Abbreviations</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space">The Promise of Pneumatology<br/><i>Cosmological Emptiness and the Spirit of God</i></span></a></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space">The Identity of Christ<br/><i>Logos and Spirit</i></span></span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space">The Anointed Son<br/><i>Toward a Sustainable Spirit-Christology</i></span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space">God’s Spirit as Transformative Power<br/><i>Voices from the Reformed Tradition</i></span></span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space">The Threefold Office<br/><i>Criterion for Living the Christian Life</i></span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space">Eyes and Ears Open to the World<br/><i>Discernment and Hope</i></span></span></p>
<p class="Toc1" id="bib"><a id="page_viii"></a><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc1" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index of Authors</span></p>
<p class="Toc1" id="idx-002"><span href="#/xhtml/index002#idx002" title="Link target outside of Sample">Index of Subjects</span></p>
<p class="Toc1" id="idx-003"><span href="#/xhtml/index003#idx003" title="Link target outside of Sample">Index of Scripture References</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?46a4f32e